import PropTypes from "prop-types";
import React, { useState } from "react";
import { updatePageConfig } from "../../../api/page";
import AveragePricePerSqftChart from "../../common/AveragePricePerSqftChart";
import { useLive } from "../LiveProvider";

function LiveAveragePricePerSqftChart({
  graphType,
  hoverListingId,
  previewListingId,
  setPreviewListingId
}) {
  const { subjectProperty, visibleListings, getModuleConfig, report } =
    useLive();
  const pageConfig = getModuleConfig("average-price-per-sqft");
  const [showSubjectPropertyIcon, setShowSubjectPropertyIcon] = useState(
    !!pageConfig.showSubjectProperty
  );
  const [showTrendline, setShowTrendline] = useState(
    !!pageConfig.showTrendline
  );

  return (
    <AveragePricePerSqftChart
      subjectProperty={subjectProperty}
      graphType={graphType}
      listings={visibleListings}
      hoverListingId={hoverListingId}
      previewListingId={previewListingId}
      setPreviewListingId={setPreviewListingId}
      showSubjectPropertyIcon={showSubjectPropertyIcon}
      setShowSubjectPropertyIcon={setShowSubjectPropertyIcon}
      showTrendline={showTrendline}
      setShowTrendline={(showTrendline) => {
        updatePageConfig(report.id, "average_price_per_sqft", {
          showTrendline
        });
        setShowTrendline(showTrendline);
      }}
    />
  );
}

LiveAveragePricePerSqftChart.defaultProps = {
  setPreviewListingId: () => {}
};

LiveAveragePricePerSqftChart.propTypes = {
  graphType: PropTypes.string,
  hoverListingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  previewListingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setPreviewListingId: PropTypes.func
};

export default LiveAveragePricePerSqftChart;
